module.exports = __webpack_public_path__ + "img/lv-flag.8b22c4dd.svg";